<template>
    <v-form ref="etapePaiement" id="etapePaiement" v-model="$storeCandidature.etapePaiementValide" lazy-validation>
        <v-container grid-list-md text-xs-center>
            <div v-if="this.$storeCandidature.sasCandidature.ModePaiementId == $storeCandidature.configurationClient.ModePaiementCbId" class="text-center">
                <!-- Paiement par carte banquaire -->
                <v-card text-center>
                    <div id="aPayer" v-if="$storeCandidature.paiemenyDto.MontantPaiement && $storeCandidature.paiemenyDto.MontantPaiement > 0">
                        <h3>{{$storeCandidature.langueFormulaire == 'en' ? 'Your application fees total :' : 'Les frais de votre dossier s\'élèvent à '}} {{$storeCandidature.paiemenyDto.MontantPaiement}} €</h3>
                    </div>
                    <div id="exempte" v-if="!$storeCandidature.paiemenyDto.MontantPaiement || $storeCandidature.paiemenyDto.MontantPaiement == 0">
                        <h3>
                            {{$storeCandidature.langueFormulaire == 'en' ? 'You are exempt from application fees. Go to the next stage.' : 'Vous êtes exempté des frais de candidature. Passez à l\'étape suivante.'}}
                        </h3>
                    </div>
                    <form id="mercPai" v-if="$storeCandidature.paiemenyDto.IdMarchand || paiementOK" method="post" :action=$storeCandidature.paiemenyDto.URLPayement>
                        <input type="hidden" name="Data" :value=$storeCandidature.paiemenyDto.Data>
                        <input type="hidden" name="InterfaceVersion" :value=$storeCandidature.paiemenyDto.VersionInterface>
                        <input type="hidden" name="Seal" :value=$storeCandidature.paiemenyDto.SealCode>
                        <v-btn tile outlined color="orange darken-2" class="mt-4" :disabled="paiementOK" :loading="paiLoading" @click="startPaiement">
                            {{$storeCandidature.langueFormulaire == 'en' ? 'Proceed to payment' : 'Procéder au paiement'}}
                            <v-icon class="ml-3">credit_card</v-icon>
                        </v-btn>
                    </form>
                    <div v-else>
                        <v-btn tile outlined color="red--text" class="mt-4">
                            {{$storeCandidature.langueFormulaire == 'en' ? 'Cannot pay with credit card, please contact the school' : 'Impossible de payer par carte bancaire, veuillez contacter l\'école'}}
                        </v-btn>
                    </div>
                    <br />
                </v-card>
            </div>
            <div v-if="this.$storeCandidature.sasCandidature.ModePaiementId == $storeCandidature.configurationClient.ModePaiementChequeId">
                <v-card>
                    <div class="text-center">
                        <div id="aPayer" v-if="$storeCandidature.paiemenyDto.MontantPaiement && $storeCandidature.paiemenyDto.MontantPaiement > 0">
                            <h3>{{$storeCandidature.langueFormulaire == 'en' ? 'Your application fees total :' : 'Les frais de votre dossier s\'élèvent à '}} {{$storeCandidature.paiemenyDto.MontantPaiement}} €</h3>
                        </div>
                        <div id="exempte" v-if="!$storeCandidature.paiemenyDto.MontantPaiement || $storeCandidature.paiemenyDto.MontantPaiement == 0">
                            <h3>
                                {{$storeCandidature.langueFormulaire == 'en' ? 'You are exempt from application fees. Go to the next stage.' : 'Vous êtes exempté des frais de candidature. Passez à l\'étape suivante.'}}
                            </h3>
                        </div>
                        <!-- Paiement par cheque-->
                        <h5>
                            {{$storeCandidature.langueFormulaire == 'en' ? 'Enter your check number and it will be validated later by the school' : 'Saisissez votre numéro de chèque et il sera validé ultérieurement par l\'école'}}
                        </h5>
                        <v-layout xs12 class="text-xs-center">
                            <v-spacer xs4></v-spacer>
                            <v-flex xs4>
                                <v-text-field :counter="50"
                                              v-model="$storeCandidature.sasCandidature.NCheque"
                                              :label="$storeCandidature.langueFormulaire == 'en' ? 'Cheque number' : 'Numero de chèque'"
                                              @change="majModePaiement"
                                              :disabled="paiementOK">
                                </v-text-field>
                            </v-flex>
                            <v-spacer xs4></v-spacer>
                        </v-layout>
                    </div>
                    <br />
                </v-card>
            </div>
            <div v-if="this.$storeCandidature.sasCandidature.ModePaiementId == $storeCandidature.configurationClient.ModePaiementVirementId" class="text-center">
                <v-card>
                    <div id="aPayer" v-if="$storeCandidature.paiemenyDto.MontantPaiement && $storeCandidature.paiemenyDto.MontantPaiement > 0">
                        <h3>{{$storeCandidature.langueFormulaire == 'en' ? 'Your application fees total :' : 'Les frais de votre dossier s\'élèvent à '}} {{$storeCandidature.paiemenyDto.MontantPaiement}} €</h3>
                    </div>
                    <div id="exempte" v-if="!$storeCandidature.paiemenyDto.MontantPaiement || $storeCandidature.paiemenyDto.MontantPaiement == 0">
                        <h3>
                            {{$storeCandidature.langueFormulaire == 'en' ? 'You are exempt from application fees. Go to the next stage.' : 'Vous êtes exempté des frais de candidature. Passez à l\'étape suivante.'}}
                        </h3>
                    </div>
                    <v-layout row wrap xs12 justify-center>
                        <v-flex xs6 md3 pl-5>
                            <v-switch :label="$storeCandidature.langueFormulaire == 'en' ? 'Pay by bank transfer' : 'Payer par virement bancaire'"
                                      v-model="$storeCandidature.sasCandidature.PaiementVirement"
                                      @change="majModePaiement"
                                      :disabled="paiementOK">
                            </v-switch>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-spacer></v-spacer>
                        <v-flex>
                            <v-card v-if="$storeCandidature.sasCandidature.PaiementVirement" class="mx-15">
                                <h2 id="compteEcole" style="color:gray">
                                    {{$storeCandidature.paiemenyDto.CompteBancaire}}
                                </h2>
                                <h5>
                                    {{$storeCandidature.langueFormulaire == 'en' ? 'Make the transfer to this account. Your payment will be confirmed upon receipt by the school' : 'Réalisez le virement vers ce compte, votre paiement sera validé dès réception par l\'école'}}
                                </h5>
                            </v-card>
                        </v-flex>
                        <v-spacer></v-spacer>
                    </v-layout>
                    <br />
                </v-card>
            </div>
            <div v-if="this.$storeCandidature.sasCandidature.ModePaiementId == $storeCandidature.configurationClient.ModePaiementCodePromoId" class="text-center">
                <v-card>
                    <div id="aPayer" v-if="$storeCandidature.paiemenyDto.MontantPaiement && $storeCandidature.paiemenyDto.MontantPaiement > 0">
                        <h3>{{$storeCandidature.langueFormulaire == 'en' ? 'Your application fees total :' : 'Les frais de votre dossier s\'élèvent à '}} {{$storeCandidature.paiemenyDto.MontantPaiement}} €</h3>
                    </div>
                    <div id="exempte" v-if="!$storeCandidature.paiemenyDto.MontantPaiement || $storeCandidature.paiemenyDto.MontantPaiement == 0">
                        <h3>
                            {{$storeCandidature.langueFormulaire == 'en' ? 'You are exempt from application fees. Go to the next stage.' : 'Vous êtes exempté des frais de candidature. Passez à l\'étape suivante.'}}
                        </h3>
                    </div>
                    <!-- Paiement par code promo-->
                    <div>
                        <h5>
                            {{$storeCandidature.langueFormulaire == 'en' ? 'Enter your promo code' : 'Saisissez votre code promo'}}
                        </h5>
                        <v-layout xs12 class="text-xs-center">
                            <v-flex xs4></v-flex>
                            <v-flex xs4>
                                <v-text-field mb-0 pb-0 :counter="50"
                                              v-model="$storeCandidature.sasCandidature.CodePromoEtudiant"
                                              label="Code promo"
                                              @change="majModePaiement"
                                              :disabled="paiementOK">
                                </v-text-field>
                                <p class="text-sm-left red--text" v-if="!codePromoValide && codePromoInvalide">Code invalide</p>
                            </v-flex>
                            <v-flex xs2>
                                <v-icon large color="success" v-if="codePromoValide && !codePromoInvalide">done_outline sss</v-icon>

                                <v-icon large color="red" v-if="!codePromoValide && codePromoInvalide">cancel sss</v-icon>
                            </v-flex>
                        </v-layout>
                    </div>
                    <br />
                </v-card>
            </div>
            <v-tabs centered v-model="$storeCandidature.sasCandidature.ModePaiementId">
                <v-tab id="carte" href="#1005511"
                       v-if="$storeCandidature.configurationClient.ParamFormulaire.ListeIdModePaiementProposes && $storeCandidature.configurationClient.ParamFormulaire.ListeIdModePaiementProposes.includes($storeCandidature.configurationClient.ModePaiementCbId)"
                       :disabled="$storeCandidature.sasCandidature.PaiementVirement || !(!$storeCandidature.sasCandidature.NCheque || $storeCandidature.sasCandidature.NCheque == '') || !(!$storeCandidature.sasCandidature.CodePromoEtudiant || $storeCandidature.sasCandidature.CodePromoEtudiant == '')">
                    <v-icon left>credit_card</v-icon>
                    <div v-if="$storeCandidature.langueFormulaire == 'en'">By credit card</div>
                    <div v-else>
                        Par Carte bancaire
                    </div>
                </v-tab>
                <v-tab id="cheque" href="#1005512"
                       v-if="$storeCandidature.configurationClient.ParamFormulaire.ListeIdModePaiementProposes && $storeCandidature.configurationClient.ParamFormulaire.ListeIdModePaiementProposes.includes($storeCandidature.configurationClient.ModePaiementChequeId)"
                       :disabled="$storeCandidature.sasCandidature.PaiementVirement || !(!$storeCandidature.sasCandidature.CodePromoEtudiant || $storeCandidature.sasCandidature.CodePromoEtudiant == '')">
                    <v-icon left>mail_outline</v-icon>
                    <div v-if="$storeCandidature.langueFormulaire == 'en'">By cheque</div>
                    <div v-else>Par Chèque</div>
                </v-tab>
                <v-tab id="virement" href="#1005513"
                       v-if="$storeCandidature.configurationClient.ParamFormulaire.ListeIdModePaiementProposes && $storeCandidature.configurationClient.ParamFormulaire.ListeIdModePaiementProposes.includes($storeCandidature.configurationClient.ModePaiementVirementId)"
                       :disabled="!(!$storeCandidature.sasCandidature.NCheque || $storeCandidature.sasCandidature.NCheque == '') || !(!$storeCandidature.sasCandidature.CodePromoEtudiant || $storeCandidature.sasCandidature.CodePromoEtudiant == '')">
                    <v-icon left>account_balance</v-icon>
                    <div v-if="$storeCandidature.langueFormulaire == 'en'">By wire transfer</div>
                    <div v-else>Par Virement Bancaire</div>
                </v-tab>
                <v-tab id="virement" href="#3920"
                       v-if="$storeCandidature.configurationClient.ParamFormulaire.ListeIdModePaiementProposes && $storeCandidature.configurationClient.ParamFormulaire.ListeIdModePaiementProposes.includes($storeCandidature.configurationClient.ModePaiementCodePromoId)"
                       :disabled="$storeCandidature.sasCandidature.PaiementVirement || !(!$storeCandidature.sasCandidature.NCheque || $storeCandidature.sasCandidature.NCheque == '')">
                    <v-icon left>local_offer</v-icon>
                    <div v-if="$storeCandidature.langueFormulaire == 'en'">By promo code</div>
                    <div v-else>Par Code Promo</div>
                </v-tab>
            </v-tabs>
            <!-- Zone Payement-->
            <div class="font-weight-black mt-4 text-center">
                <div v-if="this.$storeCandidature.ValiderPaiement()">
                    <div class="green--text">
                        {{$storeCandidature.langueFormulaire == 'en' ? 'Payment confirmed' : 'Paiement validé'}}
                    </div>
                    <v-icon x-large color="green darken-2">done_outline</v-icon>
                </div>
            </div>
            <MessageDialog v-model="flagErreur"
                           v-bind:titre="$storeCandidature.langueFormulaire == 'en' ? 'Unable to initiate payment' : 'Impossible de lancer le paiement'"
                           v-bind:message="messageErreur" />
        </v-container>
    </v-form>
</template>

<script>

    import MessageDialog from './dialog/DialogWarningUtilisateur.vue'

    export default {
        components: {
            MessageDialog
        },


        data() {
            return {
                // Réaffecter l'objet global pour forcer la maj en temps réel
                $storeCandidature: this.$storeCandidature,

                paiLoading: false,
                codePromoValide: false,
                codePromoInvalide: false,
                flagErreur: false,
                messageErreur: ''
            }
        },

        computed: {
            // Vérifier si l'étudiant a des frais à payer
            paiementOK() {
                return this.$storeCandidature.sasCandidature.PaiementRealise ||
                    !this.$storeCandidature.paiemenyDto.MontantPaiement ||
                    this.$storeCandidature.paiemenyDto.MontantPaiement == 0
            },
        },

        methods: {
            //affiche ou masque la zone de saisie de N° cheque
            majModePaiement() {
                this.$storeCandidature.candidatureChanged = true;

                // init la validité du code promo

                this.$storeCandidature.etapePaiementValide = true
                this.$storeCandidature.sasCandidature.CodePromo = null
                this.codePromoValide = false
                this.codePromoInvalide = false

                if (this.$storeCandidature.sasCandidature.NCheque) {
                    this.$storeCandidature.sasCandidature.ModePaiement = { Id: this.$storeCandidature.configurationClient.ModePaiementChequeId }
                    this.$storeCandidature.ValidationPaiementOK = true;
                }
                else if (this.$storeCandidature.sasCandidature.PaiementVirement) {
                    this.$storeCandidature.sasCandidature.ModePaiement = { Id: this.$storeCandidature.configurationClient.ModePaiementVirementId }
                    this.$storeCandidature.ValidationPaiementOK = true;
                }
                else {
                    if (this.$storeCandidature.sasCandidature.CodePromoEtudiant) {

                        this.$storeCandidature.sasCandidature.ModePaiement = { Id: this.$storeCandidature.configurationClient.ModePaiementCodePromoId }

                        // Appeler le service de validation du code promo
                        this.$storeCandidature.verifierValiditeCodePromo()
                            .then(response => {
                                // Success
                                this.$storeCandidature.sasCandidature.CodePromo = response.data
                                if (this.$storeCandidature.sasCandidature.CodePromo) {
                                    // Mettre à jour le statut de paiement
                                    if (this.$storeCandidature.sasCandidature.CodePromo) {
                                        this.codePromoValide = true
                                        this.codePromoInvalide = false
                                        this.$storeCandidature.etapePaiementValide = true
                                        this.$storeCandidature.ValidationPaiementOK = true
                                    }
                                    else {
                                        this.codePromoValide = false
                                        this.codePromoInvalide = true
                                        this.$storeCandidature.etapePaiementValide = false
                                        this.$storeCandidature.ValidationPaiementOK = false
                                    }
                                }
                                else {
                                    this.codePromoValide = false
                                    this.codePromoInvalide = true
                                    this.$storeCandidature.etapePaiementValide = false
                                    this.$storeCandidature.ValidationPaiementOK = false
                                }
                            });

                    } else {
                        this.$storeCandidature.ValidationPaiementOK = false;
                        this.$storeCandidature.sasCandidature.ModePaiement = { Id: this.$storeCandidature.configurationClient.ModePaiementCbId }
                    }
                }
            },

            // Apel du service des informations de paiement et 'submit' du formulaire
            startPaiement() {
                // Init message and flag
                this.paiLoading = true
                this.$storeCandidature.loadingCandidature = true
                this.messageErreur = this.$storeCandidature.langueFormulaire == 'en' ? "Unable to update application and initiate payment." : "Impossible de mettre à jour la candidature pour lancer le paiement."

                // Appeler le webservice d'initialisation de paiement
                this.$storeCandidature.majInfosPaiement(this.$storeCandidature.sasCandidature.IdCrypte, this.$storeCandidature.sasCandidature.KeyCrypte, this.$storeCandidature.paiemenyDto.ReferenceTransaction)
                    .then(response => {
                        if (response.data) {
                            switch (response.data) {
                                case '1':
                                    response.data;
                                    // submit du formulaire
                                    document.forms["mercPai"].submit()
                                    break
                                case '2':
                                    // message si pas de données retourné
                                    this.messageErreur = this.$storeCandidature.langueFormulaire == 'en' ? 'Application not found.' : 'Candidature introuvable.'
                                    this.loaderEndShowMessage()
                                    break
                                case '3':
                                    // message si pas de données retourné
                                    this.messageErreur = this.$storeCandidature.langueFormulaire == 'en' ? "The status of your application is 'paid'. Please reload your application to verify." : "Le statut de votre candidature est en 'payé'. Merci de recharger votre candidature pour vérifier."
                                    this.loaderEndShowMessage()
                                    break
                                default:
                                    // message si pas de données retourné
                                    this.loaderEndShowMessage()
                                    break

                            }
                        }
                        else {
                            // message si pas de données retourné
                            this.loaderEndShowMessage()
                        }
                    })
                    .catch(error => {
                        if (error) {
                            this.loaderEndShowMessage()
                        }
                    });
            },

            // Fonction de fin de cahrgement
            loaderEndShowMessage() {
                this.flagErreur = true
                this.paiLoading = false
                this.$storeCandidature.loadingCandidature = false
            }
        },
    }
</script>
